import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { LanguageProvider } from "./contexts/LanguageContext";
import { FiltersProvider } from "@/contexts/FiltersContext";
import Layout from "./components/Layout";
import LandingPage from "./pages/LandingPage";
import Index from "./pages/Index";
import Projects from "./pages/Projects";
import ProjectDetail from "./pages/ProjectDetail";
import Organizations from "./pages/Organizations";
import TransactionConfirmation from "./pages/TransactionConfirmation";
import Dashboard from "./pages/Dashboard";
import IntegrationGuide from "./pages/IntegrationGuide";
import NotFound from "./pages/NotFound";
import { FathomAnalytics } from "./components/shared/FathomAnalytics";

const queryClient = new QueryClient();

const App = () => (
  <FiltersProvider>
    <QueryClientProvider client={queryClient}>
      <TooltipProvider>
        <Toaster />
        <Sonner />
        <BrowserRouter>
          <FathomAnalytics />
          <LanguageProvider>
            <Routes>
              {/* Default English routes (/) */}
              <Route element={<Layout />}>
                <Route path="/" element={<LandingPage />} />
                <Route path="/transactions" element={<Index />} />
                <Route path="/projects" element={<Projects />} />
                <Route
                  path="/projects/:projectId"
                  element={<ProjectDetail />}
                />
                <Route path="/organizations" element={<Organizations />} />
                <Route
                  path="/contribute/confirmation"
                  element={<TransactionConfirmation />}
                />
              </Route>

              {/* Dashboard routes (outside of Layout to have a custom layout) */}
              <Route path="/contribute/dashboard" element={<Dashboard />} />
              <Route
                path="/contribute/dashboard/integration-guide"
                element={<IntegrationGuide />}
              />
              <Route path="/en/contribute/dashboard" element={<Dashboard />} />
              <Route
                path="/en/contribute/dashboard/integration-guide"
                element={<IntegrationGuide />}
              />
              <Route path="/de/contribute/dashboard" element={<Dashboard />} />
              <Route
                path="/de/contribute/dashboard/integration-guide"
                element={<IntegrationGuide />}
              />

              {/* English routes with /en prefix */}
              <Route path="/en" element={<Navigate to="/" replace />} />
              <Route path="/en/*" element={<Layout />}>
                <Route path="transactions" element={<Index />} />
                <Route path="projects" element={<Projects />} />
                <Route path="projects/:projectId" element={<ProjectDetail />} />
                <Route path="organizations" element={<Organizations />} />
                <Route
                  path="contribute/confirmation"
                  element={<TransactionConfirmation />}
                />
              </Route>

              {/* German routes with /de prefix */}
              <Route path="/de" element={<Layout />}>
                <Route index element={<LandingPage />} />
                <Route path="transactions" element={<Index />} />
                <Route path="projects" element={<Projects />} />
                <Route path="projects/:projectId" element={<ProjectDetail />} />
                <Route path="organizations" element={<Organizations />} />
                <Route
                  path="contribute/confirmation"
                  element={<TransactionConfirmation />}
                />
              </Route>

              {/* Catch-all route */}
              <Route path="*" element={<NotFound />} />
            </Routes>
          </LanguageProvider>
        </BrowserRouter>
      </TooltipProvider>
    </QueryClientProvider>
  </FiltersProvider>
);

export default App;
